<template>
  <div v-if="cameraList" style="display: flex; flex-wrap: wrap; height: 100%; overflow-y: scroll">
    <div class="caiChangeModule indexJust" v-if="loading">
      <loadingModule></loadingModule>
    </div>
    <div class="caiChangeModule indexJust" v-if="!loading && cameraList.length === 0">
      <noData></noData>
    </div>
    <div
      v-for="(item, index) in cameraList"
      @click="playDetail(item, index)"
      :class="isFullScreen ? 'videoAll' : 'video'"
      :key="index"
      v-show="!loading && cameraList.length > 0"
    >
      <div style="width: 40%; height: 100%; position: relative">
        <div style="width: 100%; height: 100%" v-html="item.html"></div>
        <div
          v-if="item.deviceStatus == 0"
          style="
            position: absolute;
            right: 0;
            top: 0;
            background: #30bf30;
            opacity: 0.9;
            width: 50%;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
            border-radius: 0 0 0 20px;
            color: white;
          "
        >
          实时监控中
        </div>
        <div
          v-if="item.deviceStatus == 1"
          style="
            position: absolute;
            right: 0;
            top: 0;
            background: #f5222d;
            opacity: 0.9;
            width: 50%;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
            border-radius: 0 0 0 20px;
            color: white;
          "
        >
          设备已离线
        </div>
      </div>
      <div style="width: 58%; display: flex; flex-direction: column; justify-content: space-between">
        <div class="videtext">屠宰场:{{ item.butcherName }}</div>
        <div class="videtext">所属辖区:{{ item.butcherAddress }}</div>
        <div class="videtext">
          屠宰类型:{{
            item.livestockType == 1
              ? '羊'
              : item.livestockType == 2
              ? '猪'
              : item.livestockType == 3
              ? '牛'
              : item.livestockType == 4
              ? '驴'
              : item.livestockType == 5
              ? '鸡'
              : item.livestockType == 0
              ? '其他'
              : ''
          }}
        </div>
      </div>
    </div>
    <div class="videoFlex" v-if="videoLoading">
      <div class="videoFlex-box">
        <div class="videoFlex-cloes" @click="videoCloes"></div>
        <div class="videoFlex-title">{{ videoInfo.butcherName }}</div>
        <div class="videoFlex-all">
          <easyplayerVideo :camera="videoInfo" v-if="videoInfo.videoSrc"></easyplayerVideo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getScreenButcherNewDataList } from '@/api/zzry';

import loadingModule from '@/views/businessModule/loading1.vue';
import noData from '@/views/businessModule/noData.vue';

import easyplayerVideo from '@/components/easyplayerVideo.vue';

export default {
  name: 'projectTop',
  created() {
    let info = JSON.parse(localStorage.getItem('info'));
    this.loading = true;
    getScreenButcherNewDataList({
      areaId: info.authProvincesCityAreas
    })
      .then(res => {
        console.log(res);
        this.loading = false;
        this.cameraList = res.data.data;
        if (this.cameraList.length > 0) {
          this.cameraList.forEach(item => {
            if (item.deviceImgUrl) {
              item.html =
                '<video class="video video-js vjs-big-play-centered  vjs-default-skin" style="object-fit: cover; width: 100%;height: 100%;" id=' +
                `myVideo${item.deviceId}` +
                ' poster=' +
                item.deviceImgUrl +
                ' muted ></video>';
            } else {
              item.html =
                '<video class="video video-js vjs-big-play-centered  vjs-default-skin" style="object-fit: cover; width: 100%;height: 100%;" id=' +
                `myVideo${item.deviceId}` +
                ' poster=' +
                '../assets/images/img2.png' +
                ' muted ></video>';
            }
            item.play_status = false;
          });
        }
      })
      .catch(() => {
        this.loading = false;
      });
  },
  mounted() {},
  props: {
    speed: {
      default: 1,
      type: Number
    }
  },
  computed: {},
  components: {
    loadingModule,
    noData,
    easyplayerVideo
  },
  data() {
    return {
      videoLoading: false,
      videoInfo: null,
      livestockList: [
        {
          label: '羊',
          value: 1
        },
        {
          label: '猪',
          value: 2
        },
        {
          label: '牛',
          value: 3
        },
        {
          label: '驴',
          value: 4
        },
        {
          label: '鸡',
          value: 5
        },
        {
          label: '其他',
          value: 0
        }
      ],
      farmInfo: null,
      cameraList: [],
      videoIndex: '',
      isFullScreen: false,
      videoOptions: {
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        autoplay: true, // 设置自动播放
        controls: true,
        controlBar: { playToggle: false },
        language: 'zh-CN',
        liveui: true,
        notSupportedMessage: '视频地址失效',
        hls: {
          withCredentials: true
        }
      },
      loading: false
    };
  },
  methods: {
    playDetail(item) {
      console.log(item, 'item')
      if (!item.play_status) {
        this.videoLoading = true;
        this.videoInfo = item;
        this.$set(item, 'videoSrc', item.deviceId);
        item.type = true;
        item.width = '100%'; // 必填摄像头宽度
        item.height = '100%'; // 必填摄像头高度
      }
    },
    videoCloes() {
      this.videoLoading = false;
    },
    getVideo(index, id, nowPlayVideoUrl) {
      this.$set(this.cameraList[index], 'player', videojs(id, this.videoOptions));
      //关键代码， 动态设置src，才可实现换台操作
      this.cameraList[index].player.src([
        {
          src: nowPlayVideoUrl,
          type: 'application/x-mpegURL' // 告诉videojs,这是一个hls流
        }
      ]);
      this.cameraList[index].player.on('fullscreenchange', this.handleFullScreenChange);
      this.videoIndex = index;
    },
    handleFullScreenChange() {
      if (this.cameraList[this.videoIndex].player.isFullscreen()) {
        // 进入全屏
        console.log('进入全屏');
        this.$emit('change', true);
      } else {
        // 退出全屏
        console.log('退出全屏');
        this.$emit('change', false);
      }
    }
  },
  beforeDestroy() {
    this.cameraList.forEach(res => {
      if (res.player) {
        res.player.dispose();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.videoFlex {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(21, 20, 20, 0.9);
  z-index: 555555;
  &-box {
    position: relative;
    width: 72%;
    height: 90%;
    background: rgba(31, 43, 55, 0.9);
    left: 14%;
    top: 5%;
    padding: 0 20px 20px 20px;
  }
  &-cloes {
    width: 40px;
    height: 40px;
    background: url('../../../static/large/exit.png');
    background-size: 100% 100%;
    position: absolute;
    right: 0;
  }
  &-title {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  &-all {
    width: 100%;
    height: calc(100% - 50px);
  }
}

::-webkit-scrollbar {
  display: none;
}
.videtext {
  padding-left: 10px;
  // line-height: 240%;
  font-size: 14px;
  color: #ffffff;
  background: linear-gradient(90deg, #0d375a 1%, rgba(8, 56, 94, 0) 100%);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 25px;
  line-height: 25px;
}
.video {
  width: 98%;
  height: 85px;
  margin-top: 2px;
  margin-bottom: 2%;
  position: relative;
  display: flex;
  justify-content: space-around;
  &-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.videoAll {
  width: 48%;
  height: 122px;
  margin-top: 4px;
  position: relative;
  &-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 26px;
  height: 26px;
  margin-left: -14px;
}

.caiChangeModule {
  width: 100%;
  height: 100%;
}
</style>
<style scoped>
/deep/ .video-js .vjs-big-play-button {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/businessModule/tucaichangRightTop-yulin.vue